import { Inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class LoggedGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router,
    @Inject(DOCUMENT) private documentEl: Document
  ) { }

  async canActivate(): Promise<boolean> {
    const url = new URL(window.location.href);
    const token = url.searchParams.get('token');
    const chatId = url.searchParams.get('chatId');
    const companyId = url.searchParams.get('companyId');
    const isLoggedIn = this.authService.isAuthenticated();


    if (isLoggedIn && chatId && companyId) {
      localStorage.setItem('chatId', chatId || '');
      localStorage.setItem('company_id', companyId || '');
      this.documentEl.body.style.setProperty('--ion-background-color', '#fff');

      localStorage.setItem('token', token || '');

      this.router.navigate(['/chatBo/' + chatId]);
      return false;
    }

    localStorage.removeItem('chatId');
    if (isLoggedIn) {
      this.router.navigate(['/home']);
      return false;
    }
    return true;
  }
}